import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import DashMetricsSource from 'sources/dashboard/DashMetricsSource';

class DashMetricsActions {
  constructor() {
    this.generateActions(
      ...generateAsyncActions(
        'userMetric',
        'teamMetric',
        'coachMetric',
        'callsForMetric',
        'topicIdsForTriggerId'
      ),
      'clearTopicIds'
    );
  }

  userMetric(metricType, params) {
    return dispatch => {
      dispatch();
      return DashMetricsSource.userMetric(metricType, params).then(
        metrics => this.userMetricSuccess({metricType, ...params}, metrics),
        this.userMetricError
      );
    };
  }

  teamMetric(metricType, params) {
    return dispatch => {
      dispatch();
      return DashMetricsSource.teamMetric(metricType, params).then(
        metrics => this.teamMetricSuccess({metricType, ...params}, metrics),
        this.teamMetricError
      );
    };
  }

  coachMetric(metricType, params) {
    return dispatch => {
      dispatch();
      return DashMetricsSource.coachMetric(metricType, params).then(
        metrics => this.userMetricSuccess({metricType, ...params}, metrics),
        this.userMetricError
      );
    };
  }

  callsForMetric(params) {
    return dispatch => {
      dispatch();
      return DashMetricsSource.callsForMetric(params).then(
        this.callsForMetricSuccess,
        this.callsForMetricError
      );
    };
  }

  topicIdsForTriggerId(triggerId) {
    return dispatch => {
      dispatch();
      return DashMetricsSource.topicIdsForTriggerId(triggerId).then(
        this.topicIdsForTriggerIdSuccess,
        this.topicIdsForTriggerIdError
      );
    };
  }
}

export default alt.createActions(DashMetricsActions);
